import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";
import { CookieHelper } from "services/cookieHelper";
@inject(HttpClient, CookieHelper)
export class AccountAPI {
  constructor(http, cookieHelper) {
    this.http = http;
    this.cookie = cookieHelper;
  }

  validateEmail(email, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.post("api/account/validateEmail", email).then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("email")) {
            successCallback(json.email);
          }

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  create(data, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.post("api/account/create", data).then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("user")) {
            if (json.hasOwnProperty("account")) {
              var sub_error = json.hasOwnProperty("sub_error")
                ? json.sub_error
                : null;
              var is_trial_expired = json.hasOwnProperty("is_trial_expired")
                ? json.is_trial_expired
                : 3;
              successCallback(
                json.user,
                json.account,
                is_trial_expired,
                sub_error
              );
            } else successCallback(json.user);
          }

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  verify_vendasta_user(data, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.post("api/tp/verify_tp_user", data).then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("vendasta")) {
            successCallback(json.vendasta);
          }

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }
  login(
    email,
    password,
    confirm_token,
    successCallback,
    errorCallback,
    vendasta_user_id = null,
    vendasta_account_id = null,
    outlookParam,
    vendasta_product_id = null
  ) {
    var cookieArr = document.cookie.split(";");
    var keep_me_loggedin = false;
    if (this.cookie.getCookie("kml") == 1) {
      keep_me_loggedin = true;
    }
    /*for(var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if("kml" == cookiePair[0].trim() && cookiePair[1] == 1) {
                keep_me_loggedin = true;
                break;
            }
        }*/
    console.log("keep me logged in" + keep_me_loggedin);
    var data = {
      email: email,
      password: password,
      confirm_token: confirm_token || "",
      vendasta_id: vendasta_user_id,
      vendasta_account_id: vendasta_account_id,
      vendasta_product_id:vendasta_product_id,
      outlookParam: outlookParam
    };

    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.post("api/account/login", JSON.stringify(data)).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("user")) {
          console.log("login data", json);

          var account = json.hasOwnProperty("account") ? json.account : null;
          var whitelabel = json.hasOwnProperty("whitelabel")
            ? json.whitelabel
            : null;
          var is_trial_expired = json.hasOwnProperty("is_trial_expired")
            ? json.is_trial_expired
            : 3;
          var user = json.user;
          var requestData = json.request_data;
          if (json.hasOwnProperty("whitelabel")) {
            console.log("login data before append", user);
            Object.assign(user, {
              payment_int_data: json.whitelabel.payment_int_data,
            });
            console.log("login data after append", user);
          }
          if (keep_me_loggedin) {
            this.cookie.setCookie("un", json.user.email, 30);
            this.cookie.setCookie("ps", password, 30);
            this.cookie.setCookie("tk", json.user.token, 30);
          } else {
            this.cookie.resetKeepmeLoggedin();
          }
          successCallback(user, account, is_trial_expired, whitelabel, requestData);
          
        }

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  loginWithSSOToken(
    token,
    url,
    successCallback,
    errorCallback,
  ) {
    var cookieArr = document.cookie.split(";");
    var keep_me_loggedin = false;
    if (this.cookie.getCookie("kml") == 1) {
      keep_me_loggedin = true;
    }
   
    // this.http = this.http.configure((x) => {
    //   x.withHeader("Content-Type", "application/json").withHeader(
    //     "Authorization",
    //     token
    //   );
    // });

    this.http.post("api/validate-token?Authorization="+token+'&webapp=true', {}).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("user")) {
          console.log("login data", json);

          var account = json.hasOwnProperty("account") ? json.account : null;
          var whitelabel = json.hasOwnProperty("whitelabel")
            ? json.whitelabel
            : null;
          var is_trial_expired = json.hasOwnProperty("is_trial_expired")
            ? json.is_trial_expired
            : 3;
          var user = json.user;
          var requestData = json.request_data;
          if (json.hasOwnProperty("whitelabel")) {
            console.log("login data before append", user);
            Object.assign(user, {
              payment_int_data: json.whitelabel.payment_int_data,
            });
            console.log("login data after append", user);
          }
          if (keep_me_loggedin) {
            this.cookie.setCookie("un", json.user.email, 30);
            this.cookie.setCookie("ps", password, 30);
            this.cookie.setCookie("tk", json.user.token, 30);
          } else {
            this.cookie.resetKeepmeLoggedin();
          }
          successCallback(user, account, is_trial_expired, whitelabel, requestData,url);
        }

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  resendConfirmation(token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.post("api/account/resendConfirmation").then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        }

        successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  agreementsChecked(token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.post("api/account/agreementsChecked").then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  changePassword(password, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    var data = {
      password: password,
    };

    this.http.post("api/account/changePassword", data).then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  changeEmail(email, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    var data = {
      email: email,
    };

    this.http.post("api/account/changeEmail", data).then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  save(data, logo_file, token, successCallback, errorCallback, profile_image) {
    console.log("data in save", data);
    console.log(profile_image);
    console.log(logo_file);
    var formData = new FormData();
    formData.append("account", JSON.stringify(data));
    if (logo_file != null) formData.append("logo_file", logo_file);

    if (profile_image != null) formData.append("profile_image", profile_image);

    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http.post("api/account/save", formData).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("account")) successCallback(json.account);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getByOwner(token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.get("api/account/getByOwner").then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("account")) successCallback(json.account);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getStorageUsed(token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.get("api/account/storage").then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("storage")) successCallback(json.storage);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getAffiliateList(
    month,
    year,
    page,
    limit,
    sortBy,
    sortDir,
    token,
    successCallback,
    errorCallback
  ) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });
    var uri = `api/account/affiliates?page=${page}&limit=${limit}&sortBy=${sortBy}&sortDir=${sortDir}`;

    if (month && year) {
      uri += `&month=${month}&year=${year}`;
    }

    this.http.get(uri).then((data) => {
      if (data.isSuccess) {
        const json = JSON.parse(data.response);

        if (json.hasOwnProperty("affiliates")) {
          successCallback(json.affiliates);
        }

        if (json.hasOwnProperty("error")) {
          errorCallback(json.error);
        }
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getAffiliateUrls(successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.get("api/account/getAffiliateUrls").then((data) => {
      if (data.isSuccess) {
        const json = JSON.parse(data.response);

        if (json.hasOwnProperty("urls")) {
          successCallback(json.urls);
        }

        if (json.hasOwnProperty("error")) {
          errorCallback(json.error);
        }
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getBusinessTypeList(successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.get("api/account/getBusinessTypeList").then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("businessTypeList"))
          successCallback(json.businessTypeList);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getRegistrationParams(successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.get("api/account/getRegistrationParams").then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("key") && json.hasOwnProperty("plus_fee"))
          successCallback(
            json.key,
            json.plus_fee,
            json.plus_yearly_fee,
            json.premium_fee,
            json.recaptcha_site_key
          );

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  sendPasswordReset(email, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    var data = {
      email: email,
    };

    this.http
      .post("api/account/sendPasswordReset", JSON.stringify(data))
      .then((data) => {
        if (data.isSuccess) {
          if (data.response) {
            var json = JSON.parse(data.response);

            if (json.hasOwnProperty("error")) errorCallback(json.error);
          } else successCallback();
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  loginWithResetPassword(
    email,
    password,
    reset_token,
    successCallback,
    errorCallback
  ) {
    var data = {
      email: email,
      password: password,
      reset_token: reset_token || "",
    };

    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http
      .post("api/account/resetPassword", JSON.stringify(data))
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("user")) {
            var account = json.hasOwnProperty("account") ? json.account : null;
            var whitelabel = json.hasOwnProperty("whitelabel")
              ? json.whitelabel
              : null;
            var is_trial_expired = json.hasOwnProperty("is_trial_expired")
              ? json.is_trial_expired
              : 3;
            var user = json.user;
            successCallback(user, account, is_trial_expired, whitelabel);
          }

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  cancelAccount(data, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.post("api/account/cancelAccount", data).then((data) => {
      if (data.isSuccess) {
        if (data.response) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else successCallback();
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  saveBizUrl(bizUrl, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http
      .post("api/account/saveBizUrl", { biz_url: bizUrl })
      .then((data) => {
        if (data.isSuccess) {
          if (data.response) {
            var json = JSON.parse(data.response);

            if (json.hasOwnProperty("biz_url")) successCallback(json.biz_url);

            if (json.hasOwnProperty("error")) errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  saveCustomOpener(
    file,
    token,
    successCallback,
    errorCallback,
    vertical = false
  ) {
    var formData = new FormData();
    if (file != null) formData.append("opener", file);

    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http
      .post(
        "api/account/saveCustomOpener" + (vertical ? "?vertical=true" : ""),
        formData
      )
      .then((data) => {
        if (data.isSuccess) {
          successCallback();
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  hasCustomOpener(query = {}, token, successCallback, errorCallback) {
    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http
      .get(
        "api/account/hasCustomOpener?" + new URLSearchParams(query).toString()
      )
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("result")) successCallback(json.result);
          else successCallback(false);
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  updateVideoReviewPageAccessCount(reviewLink, successCallback, errorCallback) {
    let data = {
      link: reviewLink,
    };
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
      // .withHeader('Authorization', token);
    });

    this.http
      .post(
        "api/wlusers/updateVideoReviewPageAccessCount",
        JSON.stringify(data)
      )
      .then((data) => {
        if (data.isSuccess) {
          successCallback();
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  getCurrencyCode(data, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http.post("api/wlusers/getCurrencyCode", data).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("currencyCode"))
          successCallback(json.currencyCode);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getUserStats(
    data,
    token,
    successCallback,
    errorCallback,
    testimonial,
    branded,
    email,
    message,
    story
  ) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    console.log(
      data +
        " <-testimonial-> " +
        testimonial +
        " <-branded-> " +
        branded +
        " <-email-> " +
        email +
        " <-message-> " +
        message +
        " <-story-> " +
        story
    );
    this.http
      .post("api/account/getVideoStats", {
        duration: data,
        testimonial: testimonial,
        branded: branded,
        email: email,
        message: message,
        story: story,
      })
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("result")) successCallback(json.result);
          else successCallback(false);
        } else {
          errorCallback(data.statusText);
        }
      });
  }
}
